<template>
  <div class="asc-parameter-threshold-table--container">
    <table class="asc-parameter-threshold-table">
      <thead class="header">
        <tr>
          <th class="header-column threshold">Threshold</th>
          <th class="header-column count">#</th>
          <th class="header-column percent">%</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.id">
          <template v-if="row.icon">
            <td class="table-cell threshold">
              <div class="withIcon">
                <asc-alert-icon :status="row.icon"></asc-alert-icon>
                <span>{{ row.name }}</span>
              </div>
            </td>
          </template>
          <template v-else>
            <td class="table-cell threshold">{{ row.name }}</td>
          </template>
          <td class="table-cell count">
            <div v-html="getCount(row.type)"></div>
          </td>
          <td class="table-cell percent">
            <div v-html="getPercentage(row.type)"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AscAlertIcon from '@/components/atoms/AscAlertIcon'

export default {
  name: 'AscParameterThresholdTable',

  components: { AscAlertIcon },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      rows: [
        {
          id: 1,
          name: 'Above Max Range',
          type: 'maxRange',
        },
        {
          id: 2,
          name: 'Low Warning',
          type: 'lowWarning',
          icon: 'lowAlarm',
        },
        {
          id: 3,
          name: 'Low Caution',
          type: 'lowCaution',
          icon: 'lowWarning',
        },
        {
          id: 4,
          name: 'Normal',
          type: 'normal',
        },
        {
          id: 5,
          name: 'High Caution',
          type: 'highCaution',
          icon: 'highWarning',
        },
        {
          id: 6,
          name: 'High Warning',
          type: 'highWarning',
          icon: 'highAlarm',
        },
        {
          id: 7,
          name: 'Below Min Range',
          type: 'minRange',
        },
        {
          id: 8,
          name: 'Total',
          type: 'total',
        },
      ],
    }
  },

  methods: {
    getCount(value) {
      return this.data && (this.data[value] || this.data[value] === 0)
        ? this.data[value]?.toLocaleString()
        : '-'
    },
    getPercentage(value) {
      if (value === 'normal') {
        const percent = (this.data.normal / this.data?.total) * 100
        return percent ? `${percent.toFixed(2)}%` : '-'
      }
      if (this.data && this.data[value] && this.data.total) {
        const percent = (this.data[value] / this.data?.total) * 100
        return percent ? `${percent.toFixed(2)}%` : '-'
      }
      return '-'
    },
  },
}
</script>

<style lang="scss">
.asc-parameter-threshold-table--container {
  height: 100%;

  .asc-parameter-threshold-table {
    border-collapse: collapse;
    border-spacing: 0;
    height: 100%;

    tr {
      border-bottom: 1px solid $gray-300;

      &:nth-child(even) {
        background-color: $gray-0;
      }
    }

    .header-column {
      background-color: $gray-300;
      font-weight: normal;
      text-transform: uppercase;
      padding: 10px;
      font-size: 12px;
      line-height: 18px;
      color: $primary-black;
      height: 38px;
      border: none;

      &.threshold {
        text-align: left;
        width: 110px;
        letter-spacing: 0.4px;
      }

      &.count {
        text-align: right;
        width: 87px;
        letter-spacing: 0;
        border-left: 1px solid $primary-white !important;
      }

      &.percent {
        text-align: right;
        width: 84px;
        letter-spacing: 0;
        border-left: 1px solid $primary-white !important;
      }
    }

    .table-cell {
      height: 18px;
      border-bottom: 1px solid $gray-300;
      color: $primary-black;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;

      &.threshold {
        width: 93px;
        color: $primary-black;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 18px;
        padding: 10px 0 10px 10px;

        .withIcon {
          display: flex;
        }
      }

      &.count {
        text-align: right;
        padding: 10px 8px 10px 10px;
      }

      &.percent {
        text-align: right;
        padding: 10px 8px 10px 10px;
      }
    }
  }
}
</style>
